// extracted by mini-css-extract-plugin
export default {"vnForm":"addVNModal_vnForm__keIAs","action_btn":"addVNModal_action_btn__XreuS"};